<template>
  <a :href="link" :title="title" class="header__actions-link flex items-center">
    <svg class="header__actions-icon">
      <use href="#compare-icon"></use>
    </svg>
    <span class="header__actions-link-label proportional-nums">
        {{ amountComparedProducts }}
    </span>
  </a>
</template>

<script>
export default {
  name:     "HeaderCompareProducts",
  props:    [
    'link',
    'title'
  ],
  computed: {
    amountComparedProducts() {
      return this.$store.state.comparedProducts.length || 0;
    },
  },
}
</script>